<template>
<div id="divInicio">
    <!-- inicio -->

    <section height="250" width="80%">
        <v-card dark>
            <v-img src="https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/FondoFiltro.png" height="250" width="100%">
                <v-carousel hide-delimiters height="250" cycle>
                    <v-carousel-item v-for="(item, i) in Titulos" :key="i">
                        <div>
                            <v-col cols="12" lg="8" offset-lg="4" class="d-none d-md-block">
                                <br>
                                <h1 class="display-2 font-weight-bold">
                                    {{item.titulo}}
                                </h1>
                                <h4 class="display-1 font-italic font-weight-light">
                                    {{item.subtitulo}}
                                </h4>
                                <br>
                                <v-btn v-if="item.btn" primary @click="mostrar(item.modal)" v-bind:href="item.vinculo">{{item.btn}}</v-btn>
                            </v-col>
                            <v-col cols="11" offset="1" class="d-none d-sm-block d-md-none">
                                <br>
                                <h1 class="headline font-weight-bold">
                                    {{item.titulo}}
                                </h1>
                                <h4 class="headline font-italic font-weight-light">
                                    {{item.subtitulo}}
                                </h4>
                                <br>
                                <v-btn v-if="item.btn" primary @click="mostrar(item.modal)" small v-bind:href="item.vinculo">{{item.btn}}</v-btn>
                            </v-col>
                            <v-col cols="11" offset="1" class="d-xs-block d-sm-none">
                                <br>
                                <p class="subtitle-1 font-weight-bold">
                                    {{item.titulo}}
                                </p>
                                <p class="subtitle-1 font-italic font-weight-light">
                                    {{item.subtitulo}}
                                </p>
                                <br>
                                <v-btn v-if="item.btn" primary @click="mostrar(item.modal)" small v-bind:href="item.vinculo">{{item.btn}}</v-btn>
                            </v-col>
                        </div>
                    </v-carousel-item>
                </v-carousel>
            </v-img>
        </v-card>
    </section>
    <section class="container">
        <v-row>
            <br>
            <v-col cols="12" sm="12" lg="8" >
                <v-row>
                    <v-col>
                        <v-carousel >
                            <v-carousel-item v-for="(item,i) in listadoNoticias" :key="i" :src="'https://smpu.nl.gob.mx'+item.url" reverse-transition="fade-transition" transition="fade-transition" :href="'/noticias/' + item.noticiaId ">
                                <v-row class="fill-height px-4 " justify="center" align="end" style="padding-bottom:6.5rem;color:white; text-transform:uppercase;background-image: linear-gradient(#00000000,#00000099);">
                                    <h1 class="display-1" >{{item.tituloNoticia}}</h1>
                                </v-row>
                            </v-carousel-item>
                        </v-carousel>
                    </v-col>
                    
                </v-row>
                <v-row >
                    <v-col cols="12" sm="12" lg="12">
                        <v-card class="mx-auto"  outlined dark color="indigo darken-4">
                            <v-col >
                            <v-card-title>
                                <h1 class="display-2">{{"$"+ new Intl.NumberFormat("en-US").format(total)}}</h1>
                            </v-card-title>
                            <v-card-subtitle class="headline">
                                Inversion de Obras y servicios
                            </v-card-subtitle>
                            </v-col>
                            <v-col >
                                <v-select v-model="seleccion" chips multiple label="Años" :items="inversion" item-text="anio" return-object clearable @change="suma()">
                                </v-select>
                            </v-col>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4">
                        <v-card class="mx-auto" outlined dark color="cyan darken-4">
                            <v-card-title>
                                <h1 class="display-2">51</h1>
                            </v-card-title>
                            <v-card-subtitle class="headline">
                                Municipios beneficiados
                            </v-card-subtitle>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4">
                        <v-card class="mx-auto"  outlined dark color="blue darken-4">
                            <v-card-title>
                                <h1 class="display-2">208</h1>
                            </v-card-title>
                            <v-card-subtitle class="headline">
                                Contratistas adjudicados
                            </v-card-subtitle>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4">
                        <v-card class="mx-auto"  outlined dark color="red darken-4">
                            <v-card-title>
                                <h1 class="display-2">416</h1>
                            </v-card-title>
                            <v-card-subtitle class="headline">
                                Total de contrataciones
                            </v-card-subtitle>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    
                    <v-col cols="12" sm="12" lg="6" xl="4">
                                <v-card class="mx-auto pa-2 ma-4" outlined dark color="deep-purple accent-2" >
                                    <v-card-title class="headline">
                                            Procesos de contratación
                                    </v-card-title>
                                    <br> 
                                    <div id="chart">
                                        <apexchart type="donut" :options="OpcionesProcesos" :series="PorcentajeProcesos"></apexchart>
                                    </div>
                                </v-card>
                    </v-col >
                    <v-col cols="12" sm="12" lg="6" xl="4">
                                    <v-card class="mx-auto pa-2 ma-4"  outlined dark color="cyan accent-4">
                                    <v-card-title class="headline">
                                        Sectores beneficiados <br> (Inversión)
                                    </v-card-title>
                                    <div id="chart">
                                        <apexchart type="donut" :options="OpcionesSectoresMonto" :series="PorcentajeSectoresMonto"></apexchart>
                                    </div>
                                    </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" lg="6" xl="4">
                                    <v-card class="mx-auto pa-2 ma-4" outlined dark color="teal accent-4">
                                        <v-card-title class="headline">
                                            Tipos de obra o servicio <br> (Contratos)
                                        </v-card-title>
                                        <div id="chart">
                                            <apexchart type="donut" :options="OpcionesObra" :series="PorcentajeObra"></apexchart>
                                        </div>
                                    </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" lg="6" xl="4">
                                <v-card class="mx-auto pa-2 ma-4" outlined dark  color="light-blue">
                                    <v-card-title class="headline">
                                            Estatus de obras
                                    </v-card-title>
                                    <br> 
                                    <div id="chart">
                                        <apexchart type="donut" :options="OpcionesEstatus" :series="PorcentajeEstatus"></apexchart>
                                    </div>
                                </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" lg="6" xl="4">
                                    <v-card class="mx-auto pa-2 ma-4"  outlined dark color="cyan accent-4">
                                    <v-card-title class="headline">
                                        Sectores beneficiados <br> (Contratos)
                                    </v-card-title>
                                    <div id="chart">
                                        <apexchart type="donut" :options="OpcionesSectores" :series="PorcentajeSectores"></apexchart>
                                    </div>
                                    </v-card>
                    </v-col>
                    
                    
                    <v-col cols="12" sm="12" lg="6" xl="4">
                                    <v-card class="mx-auto pa-2 ma-4"  outlined dark color="teal accent-4">
                                        <v-card-title class="headline">
                                            Tipos de obra o servicio <br> (Inversión)
                                        </v-card-title>
                                        <div id="chart">
                                            <apexchart type="donut" :options="OpcionesObraMonto" :series="PorcentajeObraMonto"></apexchart>
                                        </div>
                                    </v-card>
                    </v-col>
                    
                
    

                </v-row>
                <v-row class="d-none d-xl-flex">
                    <v-col>
                        <v-divider></v-divider>
                    </v-col>
                </v-row>

            </v-col>
            
            <v-col cols="12" sm="12" lg="4">
                <v-row style="padding:1rem;">
                    <v-col>
                    <v-dialog v-model="dialog3" width="1200">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-large width="100%" color="primary" v-bind="attrs" v-on="on">Próximos eventos
                                <v-icon x-large style="rotate:-15deg">event</v-icon>
                            </v-btn>
                        </template>

                        <v-card>
                            <v-card-title class="headline grey lighten-2">
                                Próximos eventos
                            </v-card-title>
                            <v-card-body>
                                <v-row class="fill-height">
                                    <v-col>
                                        <v-sheet height="64">
                                            <v-toolbar flat>
                                                <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                                                    Hoy
                                                </v-btn>
                                                <v-btn fab text small color="grey darken-2" @click="prev">
                                                    <v-icon small>
                                                        mdi-chevron-left
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn fab text small color="grey darken-2" @click="next">
                                                    <v-icon small>
                                                        mdi-chevron-right
                                                    </v-icon>
                                                </v-btn>
                                                <v-toolbar-title v-if="$refs.calendar">
                                                    {{ $refs.calendar.title }}
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-btn color="primary" outlined v-if="type != 'month'" @click="type = 'month'">Vista Mensual</v-btn>
                                            </v-toolbar>
                                        </v-sheet>
                                        <v-sheet height="600">
                                            <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :type="type" interval-height="43" first-interval="7" interval-count="12" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" locale="es-mx"></v-calendar>
                                            <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x locale="es-mx">
                                                <v-card color="grey lighten-4" min-width="350px" flat>
                                                    <v-toolbar :color="selectedEvent.color" dark>
                                                        <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <span v-html="selectedEvent.details"></span>
                                                        <br>
                                                        <br>
                                                        <span v-html="selectedEvent.numero"></span>
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-btn text color="secondary" @click="selectedOpen = false">
                                                            Cerrar
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-menu>
                                        </v-sheet>
                                    </v-col>
                                </v-row>
                            </v-card-body>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="dialog3 = false">
                                    Salir
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    </v-col>
                </v-row>
                <v-row style="padding:1rem;">
                <v-col>
                    <a href="/web/EnProceso">
                        <!--<v-img src="https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/construccion.jpg" contain max-height="150" max-width="300" class="elevation-3" alt="en proceso"></v-img>-->
                        <v-img src="https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/Actividades.jpg" contain max-height="230"  class="elevation-3" alt="en proceso"></v-img>
                        
                        <h1>Obras en proceso</h1>
                    </a>
                </v-col>
                <v-col>
                    <a href="/web/COVID">
                        <v-img src="https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/covid.svg" contain max-height="230"  class="elevation-3" alt="en proceso"></v-img>
                        
                        <h1>Hospitales COVID</h1>
                    </a>
                </v-col>
                <v-col>
                    <a href="/web/BIM">
                        <v-img src="https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/CDTFINAL.png" contain max-height="230"  class="elevation-3" alt="en proceso"></v-img>
                        
                        <h1>BIM</h1>
                    </a>
                </v-col>
                <v-col>
                    <a href="/web/AlianzaReal">
                        <v-img src="https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/alianza.jpg" contain max-height="230"  class="elevation-3"  alt="en proceso"></v-img>
                        
                        <h1>Alianza Real</h1>
                    </a>
                </v-col>
                <v-col>
                    
                    <a href="https://smpu.nl.gob.mx/transparencia/" target="_blank">
                        <v-img src="https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/InfraAbierta.png" contain max-height="230"  class="elevation-3" alt="en proceso"></v-img>
                        
                        <h1>Infraestructura Abierta</h1>
                    </a>
                </v-col>
                
                </v-row>
                <v-row class="d-xl-none">
                    <v-col>
                        <br>
                        <v-divider></v-divider>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <gmap-map :center="center" :zoom="6" style="width: 100%; height: 440px;">

            <gmap-marker v-for="Indice in InformacionContratoSerializado" :key="Indice.contratoId" :position="Indice.marcadores" :icon="Indice.icono" @click="toggleInfoWindow(Indice, Indice.contratoId)"></gmap-marker>
            <gmap-polyline v-bind:path.sync="path" v-bind:options="{ strokeColor:'#008000'}">
            </gmap-polyline>
            <gmap-polygon :paths="paths"></gmap-polygon>
            <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                <div v-html="infoContent"></div>
            </gmap-info-window>
        </gmap-map>
    </section>
    <v-dialog v-model="dialogInicio" width="900">
        <v-card>
            <v-card-title class="headline grey lighten-2">
                <h4> Avisos | Secretaría de Infraestructura</h4>
            </v-card-title>
            <v-card-text>
                <br>
                <p class="display-1">
                    Nuevo León presentó la <strong>iniciativa Infraestructura Abierta</strong>, por lo cual, paulatinamente estará publicando datos y documentos de las obras realizadas.
                </p>
                <p class="display-1">
                    La información cargada hasta el momento pueda ser consultada en el
                </p>
                <v-btn href="https://smpu.nl.gob.mx/transparencia/" target="_blank" class="primary">PORTAL DE INFRAESTRUCTURA ABIERTA</v-btn>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" text @click="dialogInicio = false">
                    salir
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog1" width="900">
        <v-card>
            <v-card-title class="headline grey lighten-2">
                <h4> Nosotros | Secretaría de Infraestructura</h4>
            </v-card-title>
            <v-card-text>
                <div class="modal-body mb-0 text-center">
                    <div class="row">
                        <img src="https://smpu.nl.gob.mx/acceso/assets/apoyocontratistas/LogoSI.svg" />
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-sm-12">
                            <h3 class="titulos">Visión</h3>
                            <br />
                            <p>
                                Trascender como la primera dependencia de un gobierno independiente reconocida a nivel nacional por su
                                modelo competitivo y de transparencia total, garantizando el uso óptimo de los recursos públicos.
                            </p>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <h3 class="titulos">Misión</h3>
                            <br />
                            <p>
                                Desarrollar obra pública de alta calidad, incluyente y de beneficio social para los habitantes de Nuevo León,
                                con eficiencia, innovación, honestidad y transparencia, atrayendo inversiones y consolidando a nuestro estado como el mejor lugar para vivir.
                            </p>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <h3 class="titulos">Responsabilidades</h3>
                            <br />
                            <p>Dependencia encargada de la proyección y construcción de las obras públicas que conciernen a la Administración Pública del Estado.</p>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <h3 class="titulos">Prioridades</h3>
                            <br />
                            <p>
                                Satisfacer las necesidades de los habitantes de Nuevo León en la creación, conservación y mejoramiento de la Infraestructura del estado,
                                con calidad, seguridad y transparencia, en un marco de sustentabilidad y respeto al medio ambiente.
                            </p>
                        </div>
                        <div>
                            <div><img src="http://www.nl.gob.mx/sites/default/files/styles/area_del_funcionario/public/ing.-jesus-humberto-torres-padilla.png?itok=eO-g59AQ" style="border:.5em solid #73AFC6; border-radius:100%;" /></div>
                            <h3 style=" font-size:2.5em;">Jesús Humberto Torres Padilla</h3>
                            <h4 style="font-family:Gotham; font-size:1.5em; font-weight:600;">Secretario de Infraestructura</h4>
                            <br />
                            <h3 class="titulos">Responsabilidades del puesto</h3>
                            <br />
                            <p>
                                Determinar, dirigir y controlar la política de la Secretaría. También someter a consideración las políticas y programas en
                                materia de obras públicas que ejecute la Administración Pública del Estado, así como proyectos estratégicos urbanos, especiales
                                o prioritarios de obra pública, dentro del ámbito de la competencia de la Secretaría.
                            </p>
                            <h3 class="titulos">Organigrama</h3>
                            <img width="800" src="https://www.nl.gob.mx/sites/default/files/10.infraestructura.jpg" />
                        </div>
                    </div>

                    <br />

                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog1 = false">
                    salir
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" width="900">
        <v-card>
            <v-card-title class="headline grey lighten-2">
                <h4> Recibe Notificaciones | Secretaría de Infraestructura</h4>
            </v-card-title>
            <v-card-text>
                <div class="modal-body mb-0 text-center">
                    <div class="row">
                        <div class="col-lg-6 col-sm-12">
                            <v-text-field name="name" label="correo electronico" id="id"></v-text-field>
                            <v-text-field name="name" label="Nombre" id="id"></v-text-field>
                        </div>
                    </div>
                    <br />
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog2 = false">
                    Registrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from 'axios'
export default {

    props: {
        // size: {
        //   type: Number,
        //   required: true,
        // },
    },

    data: () => ({
        total:7782886016.5,
        inversion: [
        {anio:'2015',importe:759814661.6},
        {anio:'2016',importe:1770074035},
        {anio:'2017',importe:1651905893},
        {anio:'2018',importe:1919468072},
        {anio:'2019',importe:1013072064},
        {anio:'2020',importe:668551290.9},
        ],
        seleccion:[],
        estatusObra:'',
        listadoNoticias: [],
        dialogInicio: false,
        dialog1: false,
        dialog2: false,
        dialog3: false,
        currentMidx: null,
        InformacionContrato: [],
        InformacionContratoSerializado: [],
        type: 'month',
        typeToLabel: {
            month: 'Mes',
            week: 'Semana',
            day: 'Día',
            '4day': '4 Días',
        },

        center: {
            lat: 25.67,
            lng: -100.29
        },
        path: [],
        paths: [],
        infoContent: '',
        infoWindowPos: {
            lat: 0,
            lng: 0
        },
        infoWinOpen: false,
        infoOptions: {
            pixelOffset: {
                width: 0,
                height: -35
            }
        },
        PorcentajeSectores: [],
        OpcionesSectores: {
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                height: '100px',
            },
            chart: {
                type: 'donut',
            },
            labels: [
                'Adquisiciones',
                'Mantenimiento',
                'Estudios de pre inversión',
                'Infraestructura Económica',
                'Infraestructura Social',
                'Infraestructura Gubernamental',
                'De inmuebles',
                'Otros',
            ],
            noData: {
                text: 'Loading...'
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 350
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
        PorcentajeSectoresMonto: [],
        OpcionesSectoresMonto: {
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                height: '100px',
            },
            chart: {
                type: 'donut',
            },
            labels: [
                'Adquisiciones',
                'Mantenimiento',
                'Estudios de pre inversión',
                'Infraestructura Económica',
                'Infraestructura Social',
                'Infraestructura Gubernamental',
                'De inmuebles',
                'Otros',
            ],
            noData: {
                text: 'Loading...'
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 350
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
        PorcentajeObra: [],
        OpcionesObra: {
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '14px',
                height: '100px',
            },
            chart: {
                type: 'donut',
            },
            noData: {
                text: 'Loading...'
            },
            labels: ['Construcción', 
            'Rehabilitación', 
            'Otros'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 350
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },PorcentajeObraMonto: [],
        OpcionesObraMonto: {
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '14px',
                height: '100px',
            },
            chart: {
                type: 'donut',
            },
            labels: [
                'Construcción', 
                'Rehabilitación', 
                'Otros'
            ],
            noData: {
                text: 'Loading...'
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 350
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
        PorcentajeEstatus: [],
        OpcionesEstatus: {
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '16px',
                height: '100px',
            },
            chart: {
                type: 'donut',
            },
            labels: ['En Ejecución', 'Concluido'],
            noData: {
                text: 'Loading...'
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 350
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
        PorcentajeProcesos: [],
        OpcionesProcesos: {
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '16px',
                height: '100px',
            },
            chart: {
                type: 'donut',
            },
            labels: ['Invitación restringida', 'Adjudicación directa', 'Licitación'],
            noData: {
                text: 'Loading...'
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 350
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
        Titulos: [{
                titulo: "Secretaría de Infraestructura",
                subtitulo: "Bienvenido",
            },
            {
                titulo: "Nosotros",
                subtitulo: "Conoce más sobre quiénes somos",
                btn: "Ver más",
                modal: "1"
            },
            {
                titulo: "Concursos",
                subtitulo: "Infórmate sobre nuevas obras y participa",
                btn: "Ver más",
                vinculo: "/concursos",
            },
            {
                titulo: "Histórico de Contratos ",
                subtitulo: "Observa las obras que hemos realizado",
                btn: "Ver más",
                vinculo: "/historicocontratospublicos",
            },
            {
                titulo: "Portal de proveedores ",
                subtitulo: "Suscríbete y entérate de las obras y licitaciones del Estado",
                btn: "Ver más",
                vinculo: "https://proveedores.nl.gob.mx/",
            },
            {
                titulo: "Regístrate aquí y recibe notificaciones",
                btn: "Ver más",
                modal: "2"
            },
            {
                titulo: "Denuncia Corrupción",
                btn: "Denunciar",
                vinculo: "http://corrupnetnl.mx",
            },
        ],
        headers: [{
                text: "Numero de Concurso",
                value: "concursoId"
            },
            {
                text: "Nombre de Concurso",
                value: "tituloConcurso"
            },
            {
                text: "Evento",
                value: "nombre"
            },
            {
                text: "Fecha",
                value: "fecha"
            },
        ],
        focus: '',
        type: 'month',
        typeToLabel: {
            month: 'Month',
            week: 'Week',
            day: 'Day',
            '4day': '4 Days',
        },
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        listadoEventos: [],
        overlay: false,
        valid: true,
        name: '',
        select: null,
    }),

    created() {
        this.listarNoticias();
        this.listarEventos();
        this.listarUbicaciones();
        this.IndicadorEnProcesoTerminado();
        this.IndicadorTipoConcurso();
        this.IndicadorTiposDeObra();
        this.IndicadorSectores();
        this.VentanaInicio();
    },
    mounted() {
    },
    methods: {
         suma(){
            let me = this;
            let cantidades = [];
            if(me.seleccion.length > 0 ){
                me.seleccion.forEach(x=> cantidades.push(x.importe));
                me.total = cantidades.reduce((a, b) => a + b, 0);
            }
            else if(me.seleccion.length <= 0){
                me.total = '7782886016.5';
            }
        
            
        },
        VentanaInicio(){
            if(!localStorage.Inicio){
                this.dialogInicio = true;
                localStorage.Inicio = true;
            }
        },
        mostrarOverlay() {

            console.log(this.$overlay);

            this.$overlay = !this.$app.overlay;
            setTimeout(() => {
                this.$app.overlay = !this.$app.overlay;
            }, 5000);

        },
        toggleInfoWindow: function (marker, idx) {
            this.infoWindowPos = marker.marcadores;
            this.infoContent = this.getInfoWindowContent(marker);
            console.log(marker.tituloConcurso);
            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
                this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
                this.infoWinOpen = true;
                this.currentMidx = idx;
            }
        },
        getInfoWindowContent: function (marker) {
            console.log("infowindow");
            console.log(marker);
            if (!(marker.urlPia == null)) {
                return (
                    `<div class="">
          <div>
            <div>
              <div class="m-2"><span style="font-weight: bold;">Titulo: </span>
                ${marker.tituloConcurso}
              </div>
            </div>

            <div class="m-2"><span style="font-weight: bold;">Estatus:  </span>
              ${marker.estatusContrato}
              <br>
            </div>
            <div class="m-2"><span style="font-weight: bold;">Numero de concurso:  </span>
              ${marker.numeroConcurso}
              <br>
            </div>
            <div class="m-2"><span style="font-weight: bold;">Numero de contrato:  </span>
              ${marker.numeroContrato}
              <br>
            </div>
            <a

            href="${marker.urlPia}" target="_blank"
            >Mas info</a>
          </div>
        </div>`);

            } else {
                return (
                    `<div class="">
          <div>
            <div>
              <div class="m-2"><span style="font-weight: bold;">Titulo: </span>
                ${marker.tituloConcurso}
              </div>
            </div>
            <div class="m-2"><span style="font-weight: bold;">Estatus:  </span>
              ${marker.estatusContrato}
              <br>
            </div>
            <div class="m-2"><span style="font-weight: bold;">Numero de concurso:  </span>
              ${marker.numeroConcurso}
              <br>
            </div>
            <div class="m-2"><span style="font-weight: bold;">Numero de contrato:  </span>
              ${marker.numeroContrato}
              <br>
            </div>
          </div>
        </div>`);
            }

        },
        mostrar(modal) {
            if (modal == 1) {
                this.dialog1 = true;
            } else if (modal == 2) {
                this.dialog2 = true;
            }
        },
        listarNoticias() {
            console.log("Listar");
            let me = this;
            // let header = {"Authorization":"Bearer " + this.$store.state.token};
            // let configuration={headers:header};
            axios.get('/listarNoticias').then(function (response) {
                console.log("Concursos:");
                console.log(response.data);
                me.listadoNoticias = response.data.reverse();
                return true;
            }).catch(function (error) {
                console.log(error);
                return false;
            });
        },
         IndicadorEnProcesoTerminado(){
          console.log("Listar EstatusObra");
            let me = this;
            axios.get('api/concursos/MostrarIndicadorEnProcesoTerminado').then(function (response) {
                console.log(response.data, "response.data");
                //aux.push(response.data);
                me.PorcentajeEstatus.push(response.data.enProceso); 
                me.PorcentajeEstatus.push(response.data.terminado);
                 
                console.log(me.PorcentajeEstatus, "me.EstatusObra");
                return true;
            }).catch(function (error) {
                console.log(error);
                return false;
            });
            me.PorcentajeEstatus = me.PorcentajeEstatus;
        },
        IndicadorTipoConcurso(){
          console.log("Listar TipoConcurso");
            let me = this;
            axios.get('api/concursos/MostrarIndicadorTipoConcurso').then(function (response) {
                console.log(response.data, "response.data");
                me.PorcentajeProcesos.push(response.data.invitacionRestringida);
                me.PorcentajeProcesos.push(response.data.adjudicacionDirecta);  
                me.PorcentajeProcesos.push(response.data.licitaciones); 
                console.log(me.PorcentajeProcesos, "me.TipoConcurso");
                return true;
            }).catch(function (error) {
                console.log(error);
                return false;
            });
            me.PorcentajeProcesos = me.PorcentajeProcesos;
        },
        IndicadorTiposDeObra(){
          console.log("Listar TipoConcurso");
            let me = this;
            axios.get('api/concursos/MostrarIndicadorTiposDeObra').then(function (response) {
                console.log(response.data, "response.data");
                me.PorcentajeObra.push(response.data.construccion);
                me.PorcentajeObra.push(response.data.rehabilitacion);  
                me.PorcentajeObra.push(response.data.otros); 
                me.PorcentajeObraMonto.push(response.data.montoConstruccion);
                me.PorcentajeObraMonto.push(response.data.montoRehabilitacion);  
                me.PorcentajeObraMonto.push(response.data.montoOtros); 
                console.log(me.PorcentajeObra, "me.PorcentajeObra", me.PorcentajeObraMonto,"me.PorcentajeObraMonto");
                return true;
            }).catch(function (error) {
                console.log(error);
                return false;
            });
            me.PorcentajeObra = me.PorcentajeObra;
            me.PorcentajeObraMonto = me.PorcentajeObraMonto;
        },
        IndicadorSectores(){
          console.log("Listar TipoConcurso");
            let me = this;
            axios.get('api/concursos/MostrarIndicadorSectores').then(function (response) {
                console.log(response.data, "response.data");
                me.PorcentajeSectores.push(response.data.adquisiciones);
                me.PorcentajeSectores.push(response.data.mantenimiento);  
                me.PorcentajeSectores.push(response.data.estudiosPreInversion);
                me.PorcentajeSectores.push(response.data.infraestructuraEconomica); 
                me.PorcentajeSectores.push(response.data.infraestructuraSocial); 
                me.PorcentajeSectores.push(response.data.infraestructuraGubernamental);
                me.PorcentajeSectores.push(response.data.deinmuebles); 
                me.PorcentajeSectores.push(response.data.otros);   
                me.PorcentajeSectoresMonto.push(response.data.adquisicionesMonto);
                me.PorcentajeSectoresMonto.push(response.data.mantenimientoMonto);  
                me.PorcentajeSectoresMonto.push(response.data.estudiosPreInversionMonto); 
                me.PorcentajeSectoresMonto.push(response.data.infraestructuraEconomicaMonto); 
                me.PorcentajeSectoresMonto.push(response.data.infraestructuraSocialMonto); 
                me.PorcentajeSectoresMonto.push(response.data.infraestructuraGubernamentalMonto); 
                me.PorcentajeSectoresMonto.push(response.data.deinmueblesMonto); 
                me.PorcentajeSectoresMonto.push(response.data.otrosMonto); 

                console.log(me.PorcentajeObra, "me.PorcentajeObra", me.PorcentajeObraMonto,"me.PorcentajeObraMonto");
                return true;
            }).catch(function (error) {
                console.log(error);
                return false;
            });
            me.PorcentajeObra = me.PorcentajeObra;
            me.PorcentajeObraMonto = me.PorcentajeObraMonto;
        },
        listarUbicaciones() {
            console.log("Listar");
            let me = this;
            axios.get('api/Contratos/ListarUbicaciones').then(function (response) {
                console.log("Ubicaciones:");
                console.log(response.data);
                me.InformacionContrato = response.data.reverse();
                console.log(me.InformacionContrato, "me.InformacionContrato");
                me.crearObjetosUbicacion();
                return true;
            }).catch(function (error) {
                console.log(error);
                return false;
            });
        },
        listarEventos() {
            console.log("Listar");
            let me = this;
            // let header = {"Authorization":"Bearer " + this.$store.state.token};
            // let configuration={headers:header};
            axios.get('/listarEventos').then(function (response) {
                console.log("Eventos:");
                console.log(response.data);
                me.listadoEventos = response.data.reverse();
                me.getEvents();
                return true;
            }).catch(function (error) {
                console.log(error);
                return false;
            });
        },
        viewDay({
            date
        }) {
            this.focus = date
            this.type = 'day'
        },
        getEvents() {
            var events = [];
            var me = this;
            me.listadoEventos.forEach(evento => {
                var fecha = evento.fecha.substr(0, 10);
                var hora = evento.hora.substr(10,3);
                console.log(fecha);
                console.log(hora);
                var min = (`${fecha}${hora}:00:00`);
                var max = (`${fecha}${hora}:59:59`);
                events.push({
                    name: evento.nombre,
                    details: evento.tituloConcurso,
                    numero: evento.numeroConcurso,
                    start: min,
                    end: max,
                    color: 'blue',
                    timed: true,
                })
            })

            this.events = events;
        },
        showEvent({
            nativeEvent,
            event
        }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                setTimeout(() => {
                    this.selectedOpen = true
                }, 10)
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                setTimeout(open, 10)
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        setToday() {
            this.focus = ''
        },
        prev() {
            this.$refs.calendar.prev()
        },
        next() {
            this.$refs.calendar.next()
        },
        crearObjetosUbicacion() {
            var me = this;

            me.InformacionContrato.forEach(element => {
                if (element.marcadores != undefined) {
                    // console.log(element.marcadores);
                    var marcadoresInternos = JSON.parse(element.marcadores);
                    var InfoUbicacion = new Object();
                    InfoUbicacion.tituloConcurso = element.tituloConcurso;
                    InfoUbicacion.contratoId = element.contratoId;
                    InfoUbicacion.concursoId = element.concursoId;
                    InfoUbicacion.numeroConcurso = element.numeroConcurso;
                    InfoUbicacion.numeroContrato = element.numeroContrato;
                    InfoUbicacion.estatusContrato = element.estatusContrato;
                    InfoUbicacion.urlPia = element.urlPia;
                    if (InfoUbicacion.estatusContrato == 'CONTRATACIÓN' || InfoUbicacion.estatusContrato == 'EN EJECUCIÓN' ||
                        InfoUbicacion.estatusContrato == 'DETENIDO' || InfoUbicacion.estatusContrato == 'INICIO DE RESCISIÓN') {
                        InfoUbicacion.icono = {
                            url: 'https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/enProceso.svg'
                        };
                    } else if (InfoUbicacion.estatusContrato == 'EN CIERRE ADMINISTRATIVO' || InfoUbicacion.estatusContrato == 'CONCLUIDO CON FIANZA DE V.O.' ||
                        InfoUbicacion.estatusContrato == 'TERMINADA FÍSICAMENTE' || InfoUbicacion.estatusContrato == 'TERMINACIÓN ANTICIPADA') {
                        InfoUbicacion.icono = {
                            url: 'https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/terminado.svg'
                        };
                        //"{ url: require('https://smpu.nl.gob.mx/acceso/assets/websi/Imagenes/building.svg')}";
                    }

                    marcadoresInternos.forEach(marcador => {
                        InfoUbicacion.marcadores = (marcador);
                    });
                    me.InformacionContratoSerializado.push(InfoUbicacion)
                }
            });

            console.log('InformacionContratoSerializado');
            console.log(me.InformacionContratoSerializado);
        },
    },
}
</script>

<style>
.v-image__image {
    transition: .3s linear;
}
</style>
